import './SimpleLoadingSpinner.css';

/**
 * This simple loading spinner component
 * @component
 */
export const SimpleLoadingSpinner = () => {
	return (
		<div className="simple-loading-spinner">
			<div />
			<div />
			<div />
			<div />
		</div>
	);
};

export default SimpleLoadingSpinner;
